import './_event-delegation'

// Modalbox class {
//     1. To append Youtube video to modalbox, give the btnSelector a data-url attribute with the youtube url
//     2. To append mp4 video to modalbox, give the btnSelector a data-url attribute with the complete path to the mp4 video
//     3. To append Vimeo video to modalbox, give the btnSelector a data-url attribute with the vimeo url
// }

// Accepts 1 parameter which is the btnSelector etc. new Modalbox('.play-btn');

export default class Modalbox {

  constructor (btnSelector) {

    this.opened = false
    this.removed = true

    document.body.on('click', btnSelector, (e, el) => {
      e.preventDefault()
      this.open()
      this.play(el.getAttribute('data-url'))
    })

    // Adding escape press event listeners
    document.addEventListener('keydown', (e) => {
      const KEY_NAME = e.key
      if (KEY_NAME == 'Escape' && this.opened == true) {
        this.close()
      }
    })

  }

  // Creates html for the modalbox and adding click event on overlay
  create () {
    const MODAL = document.querySelector('.video-modal')
    if (!MODAL) {

      // Creating the video modal box
      this.modalbox = document.createElement('div')
      this.modalbox.className = 'video-modal'
      this.modalboxInner = document.createElement('div')
      this.modalboxInner.className = 'video-modal-content'

      // Creating close button
      this.closeButton = document.createElement('button')
      this.closeButton.className = 'video-modal-close-button'
      this.closeButton.setAttribute('aria-label', 'Close video modal')

      // Appending modalbox and content
      document.body.appendChild(this.modalbox)
      this.modalbox.appendChild(this.modalboxInner)

      // Creating and appending the video modal box overlay
      this.modalboxOverlay = document.createElement('div')
      this.modalboxOverlay.className = 'video-overlay'
      document.body.appendChild(this.modalboxOverlay)
      this.modalboxOverlay.appendChild(this.closeButton)

      // Adding click event listeners on overlay
      document.getElementsByClassName('video-overlay')[0].addEventListener('click', () => {
        this.close()
      })

      this.removed = false

    }
  }

  // Removing html making the html more clean when not using it
  remove () {
    if (this.modalbox) {
      document.body.removeChild(this.modalbox)
      document.body.removeChild(this.modalboxOverlay)
    }
  }

  // Appends mobdalbox and Adds open-video class to body and active to this.modalbox
  open () {
    if (this.removed = true) {
      this.opened = true
      this.create()
      // Setting a small timeout to make the modalbox append before animating
      setTimeout(() => {
        document.body.className += ' open-video'
      }, 10)
      setTimeout(() => {
        document.body.className += ' video-open'
      }, 300)
    }
  }

  // Adds close-video class to body to begin close animation and removing open-video after a certain delay relative to window.innerWidth
  close () {

    this.opened = false

    document.body.className += ' close-video'

    setTimeout(() => {
      document.body.className = document.body.className.replace(/\bopen-video\b/g, '')
      document.body.className = document.body.className.replace(/\bvideo-open\b/g, '')
      this.modalboxInner.innerHTML = ''
    }, 500)

    const WIDTH = window.innerWidth

    if (this.removed == false) {
      this.removed = true

      setTimeout(() => {
        document.body.className = document.body.className.replace(/\bclose-video\b/g, '')
        this.modalbox.className = this.modalbox.className.replace(/\bactive\b/g, '')
        this.remove()
      }, 500)
    }
  }

  // Appends an iframe or mp4 file to this.modalboxInner
  play (videoUrl) {
    this.modalboxInner.innerHTML += this.getIframe(videoUrl)
  }

  // Get iframe based on type
  getIframe (url) {
    const YOUTUBE_REG_EXP = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
    const YOUTUBE_MATCH = url.match(YOUTUBE_REG_EXP)

    const VIMEO_REG_EXP = /(?:http|https)?:?\/?\/?(?:www\.)?(?:player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/
    const VIMEO_MATCH = url.match(VIMEO_REG_EXP)

    if (YOUTUBE_MATCH && YOUTUBE_MATCH[2].length == 11) {
      return '<iframe id="video-modal-player" width="560" height="315" src="//www.youtube.com/embed/' + YOUTUBE_MATCH[2] + '?autoplay=1&enablejsapi=1&rel=0" frameborder="0" allowfullscreen></iframe>'
    } else if (VIMEO_MATCH && VIMEO_MATCH[1]) {
      const URL_OBJECT = new URL(url);
      const H_PARAM = URL_OBJECT.searchParams.get("h");
      let h_param_value = ''

      if(H_PARAM){
        h_param_value = 'h=' + H_PARAM + '&'
      }
      return '<iframe src="https://player.vimeo.com/video/' + VIMEO_MATCH[1] + '?' + h_param_value + 'autoplay=1" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>'
    } else {
      return '<video controls autoplay disableRemotePlayback controlsList="nodownload" id="video-modal-player"><source src="' + url + '" type="video/mp4">Your browser does not support HTML5 video.</video>'
    }
  }
}
